import BasicBlock from '../components/BasicBlock';
import TypeIcon from '../TypeIcon';
import { CardHeader } from '../components/CardHeader';
import { initiatorTypes, eventTypes } from '../../constants';
import {
  defaultEmployeeString,
  defaultSmartConnectorString,
  triggerData,
} from '../helpers';
import {
  EMPLOYEE_ACCOUNT_TYPES,
  getServiceAccountPostFix,
} from '../ts-helpers';
import { capitalizeAllWords } from 'components/helpers';

const getActionText = (type, t) => {
  if (type === eventTypes.automationStarted) {
    return t('agentic workflow started by');
  }
  if (type === eventTypes.automationPaused) {
    return t('agentic workflow paused by');
  }
  if (type === eventTypes.automationCanceled) {
    return t('agentic workflow canceled by');
  }
  if (type === eventTypes.automationResumed) {
    return t('agentic workflow resumed by');
  }
};

const cardHeaderConfig = (t, event) => {
  const prefix = getActionText(event.typeName, t);
  return {
    [initiatorTypes.employee]: {
      prefix,
      creationType: (initiator, event) => {
        if (
          initiator?.accountType === EMPLOYEE_ACCOUNT_TYPES.service_automation
        ) {
          return event?.data?.automationName
            ? event?.data?.automationName
            : initiator.firstName;
        }
        // when implemented add EMPLOYEE_ACCOUNT_TYPES.service_integration

        return defaultEmployeeString(initiator);
      },
      postfix: (event) => {
        return getServiceAccountPostFix(event.initiator.accountType, t);
      },
    },
    [initiatorTypes.employee_api_request]: {
      prefix,
      creationType: defaultEmployeeString,
      postfix: t('via API'),
    },
    [initiatorTypes.automation]: {
      prefix,
      creationType: (initiator) => `${initiator.name} ${t('agentic workflow')}`,
    },
    [initiatorTypes.smart_connector]: {
      prefix,
      creationType: defaultSmartConnectorString,
    },
    [initiatorTypes.trigger]: {
      prefix,
      creationType: (initiator, event) => {
        if (!Object.keys(triggerData).includes(event.data.triggerType))
          return `${t('Trigger')} (${capitalizeAllWords(
            initiator.triggerTypeDisplayName
          )})`;
        return `${t('Trigger')} (${triggerData[event.data.triggerType](
          event,
          t
        )})`;
      },
    },
    [initiatorTypes.system]: {
      prefix,
      creationType: () => t('Kizen Administrator'),
    },
  };
};

const AutomationStartedEventBlock = ({ event, ...others }) => {
  return (
    <BasicBlock
      comments={event.comments}
      icon={
        <TypeIcon
          color="var(--color-viz-cat-4-primary)"
          icon="sync"
          size="16px"
        />
      }
      isDeletable={false}
      timestamp={event.created}
      title={
        <CardHeader
          event={event}
          name={event.data.automationName}
          config={cardHeaderConfig}
        />
      }
      event={event}
      {...others}
    ></BasicBlock>
  );
};

export default AutomationStartedEventBlock;
